type ErrorFallbackProps = {
  error: Error
  resetError: () => void
}

function WarningIcon() {
  return (
    <div className="flex justify-center mb-4">
      <div className="h-12 w-12 rounded-full bg-red-100 flex items-center justify-center">
        <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
    </div>
  )
}

export function RootErrorFallback({ error, resetError }: ErrorFallbackProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <WarningIcon />
        <h2 className="text-xl font-semibold text-gray-900">Something went wrong</h2>
        <p className="mt-2 text-sm text-gray-500">An unexpected error occurred. Please try again.</p>
        {import.meta.env.DEV && (
          <pre className="mt-4 text-xs text-left bg-gray-100 p-3 rounded max-w-md overflow-auto text-red-700">
            {error.message}
          </pre>
        )}
        <button
          onClick={resetError}
          className="mt-6 px-4 py-2 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
        >
          Try again
        </button>
      </div>
    </div>
  )
}

export function PageErrorFallback({ error, resetError }: ErrorFallbackProps) {
  return (
    <div className="py-16 flex items-center justify-center">
      <div className="text-center">
        <WarningIcon />
        <h2 className="text-xl font-semibold text-gray-900">Page error</h2>
        <p className="mt-2 text-sm text-gray-500">
          This page encountered an error. The rest of the app should still work.
        </p>
        {import.meta.env.DEV && (
          <pre className="mt-4 text-xs text-left bg-gray-100 p-3 rounded max-w-md overflow-auto text-red-700">
            {error.message}
          </pre>
        )}
        <button
          onClick={resetError}
          className="mt-6 px-4 py-2 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
        >
          Try again
        </button>
      </div>
    </div>
  )
}
